import ChinaAmountForm from "./forms/ChinaAmountForm";
import ChinaSenderForm from "./forms/ChinaSenderForm";
import ChinaBeneficiaryForm from "./forms/ChinaBeneficiaryForm";
import ChinaReviewForm from "./forms/ChinaReviewForm";
import AliPaySenderForm from "./forms/AliPaySenderForm";
import AliPayBeneficiaryForm from "./forms/AliPayBeneficiaryForm";
import AliPayReviewForm from "./forms/AliPayReviewForm";
import UnionPaySenderForm from "./forms/UnionPaySenderForm";
import UnionPayBeneficiaryForm from "./forms/UnionPayBeneficiaryForm";
import UnionPayReviewForm from "./forms/UnionPayReviewForm";
import { FormRegistryMap } from "../../shared/types";

export const chinaFormRegistry: FormRegistryMap = {
  amount: {
    bank_account: ChinaAmountForm,
    alipay: ChinaAmountForm,
    unionpay: ChinaAmountForm,
    default: ChinaAmountForm,
  },
  sender: {
    bank_account: ChinaSenderForm,
    alipay: AliPaySenderForm,
    unionpay: UnionPaySenderForm,
    default: ChinaSenderForm,
  },
  beneficiary: {
    bank_account: ChinaBeneficiaryForm,
    alipay: AliPayBeneficiaryForm,
    unionpay: UnionPayBeneficiaryForm,
    default: ChinaBeneficiaryForm,
  },
  review: {
    bank_account: ChinaReviewForm,
    alipay: AliPayReviewForm,
    unionpay: UnionPayReviewForm,
    default: ChinaReviewForm,
  },
};
